import type { FeatureId, FeatureSettingFilters, FeatureSettingGet } from "core";
import { trpc } from "./trpc";

export function useFeatureSettings(input: FeatureSettingFilters) {
  const { data, isPending: isLoadingSettings } =
    trpc.featureSetting.getAll.useQuery(input);

  return {
    settings: data,
    isLoadingSettings,
  };
}

export function isFeatureSettingEnabled(
  featureId: FeatureId,
  settings?: { featureId: string; enabled: boolean }[],
) {
  return !!settings?.find((setting) => setting.featureId === featureId)
    ?.enabled;
}

export function useFeatureSetting(input: FeatureSettingGet) {
  const {
    data,
    isPending: isLoadingFeature,
    ...query
  } = trpc.featureSetting.get.useQuery(input);

  return {
    feature: data,
    isLoadingFeature,
    ...query,
  };
}

export function useCreateFeatureSetting() {
  const utils = trpc.useUtils();

  const {
    mutate: createFeatureSetting,
    isPending: isCreatingFeatureSetting,
    ...mutation
  } = trpc.featureSetting.create.useMutation({
    onSettled() {
      utils.featureSetting.get.invalidate();
      utils.featureSetting.getAll.invalidate();
    },
  });

  return {
    ...mutation,
    createFeatureSetting,
    isCreatingFeatureSetting,
  };
}

export function useUpdateFeatureSetting() {
  const utils = trpc.useUtils();

  const {
    mutate: updateFeatureSetting,
    isPending: isUpdatingFeatureSetting,
    ...mutation
  } = trpc.featureSetting.update.useMutation({
    onSettled() {
      utils.featureSetting.get.invalidate();
      utils.featureSetting.getAll.invalidate();
    },
  });

  return {
    ...mutation,
    updateFeatureSetting,
    isUpdatingFeatureSetting,
  };
}
